import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { ContentControlDataProtectionExclusion } from '@nirvana/shared/dtos/types/policies/common';
import { translateFn } from '../../../../../../../../../utils/translator.helper';

// validate duplicates
export function validateNameDuplicates(
  exclusionItem: ContentControlDataProtectionExclusion,
  exclusionsInGrid: ContentControlDataProtectionExclusion[]
): ValidationResult {
  const hasDuplicates = exclusionsInGrid.some(
    (exclusionInGrid: ContentControlDataProtectionExclusion) => exclusionInGrid.address === exclusionItem.address
  );

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}

export function validateSelectedRules(exclusionItem: ContentControlDataProtectionExclusion): ValidationResult {
  if (!exclusionItem.rulesToConsider.length) {
    return {
      valid: false,
      error: translateFn('Select at least one rule for this exclusion.'),
    };
  }

  return {
    valid: true,
  };
}
